import React from 'react';

const JS_Browser = () => {
  return (
    <div >
      <h1>JS_Browser</h1>
      <p>Placeholder component for: "JS Browser"</p>
    </div>
  );
};

export default JS_Browser;
